import { DatePicker, Button, Checkbox } from "antd";
import { useState } from "react";

const DateRangeFilter = ({
  setSelectedKeys,
  selectedKeys,
  confirm,
  clearFilters,
  columnKey,
  setFilteredInfo,
  setTabsData,
  selectedTab,
  reportTabName,
  setUnsavedTabs,
  filteredInfo,
}) => {
  const [localStartDate, setLocalStartDate] = useState(null);
  const [localEndDate, setLocalEndDate] = useState(null);
  const [showBlanksOnly, setShowBlanksOnly] = useState(
    Array.isArray(filteredInfo[columnKey]) &&
      filteredInfo[columnKey].length === 1 &&
      filteredInfo[columnKey][0] === ""
  );

  // console.log(filteredInfo[columnKey], "!!!");

  const handleConfirm = () => {
    if (showBlanksOnly) {
      // Filter for blank fields only
      setSelectedKeys([""]);

      setFilteredInfo((prev) => ({
        ...prev,
        [columnKey]: [""],
      }));

      const currentTabKey = selectedTab || reportTabName;
      setTabsData((prev) => ({
        ...prev,
        [currentTabKey]: {
          ...prev[currentTabKey],
          alignedData: {
            ...prev[currentTabKey]?.alignedData,
            [columnKey]: {
              ...prev[currentTabKey]?.alignedData[columnKey],
              filtering: [""],
            },
          },
        },
      }));

      setUnsavedTabs((prev) => ({
        ...prev,
        [selectedTab]: true,
      }));

      confirm();
    } else if (localStartDate && localEndDate) {
      // Filter for date range
      const formattedStartDate = localStartDate.format("MM-DD-YYYY");
      const formattedEndDate = localEndDate.format("MM-DD-YYYY");

      setSelectedKeys([formattedStartDate, formattedEndDate]);

      setFilteredInfo((prev) => ({
        ...prev,
        [columnKey]: [formattedStartDate, formattedEndDate],
      }));

      const currentTabKey = selectedTab || reportTabName;
      setTabsData((prev) => ({
        ...prev,
        [currentTabKey]: {
          ...prev[currentTabKey],
          alignedData: {
            ...prev[currentTabKey]?.alignedData,
            [columnKey]: {
              ...prev[currentTabKey]?.alignedData[columnKey],
              filtering: `${formattedStartDate},${formattedEndDate}`,
            },
          },
        },
      }));

      setUnsavedTabs((prev) => ({
        ...prev,
        [selectedTab]: true,
      }));

      confirm();
    }
  };

  const handleReset = () => {
    setLocalStartDate(null);
    setLocalEndDate(null);
    setShowBlanksOnly(false);
    setSelectedKeys([]);

    const currentTabKey = selectedTab || reportTabName;
    setTabsData((prev) => ({
      ...prev,
      [currentTabKey]: {
        ...prev[currentTabKey],
        alignedData: {
          ...prev[currentTabKey]?.alignedData,
          [columnKey]: {
            ...prev[currentTabKey]?.alignedData[columnKey],
            filtering: "",
          },
        },
      },
    }));

    clearFilters();
    confirm();
  };

  const handleBlankToggle = (checked) => {
    setShowBlanksOnly(checked);
    if (checked) {
      // Clear date selections when blank is selected
      setLocalStartDate(null);
      setLocalEndDate(null);
    } else {
      handleReset();
    }
  };

  return (
    <div style={{ padding: 8 }}>
      <div>
        <strong style={{ width: "50%", marginBottom: 8 }}>Pick a range</strong>
      </div>
      <div className="d-flex gap-2 justify-content-between">
        <DatePicker
          value={showBlanksOnly ? null : localStartDate}
          onChange={(date) => setLocalStartDate(date)}
          format="MM-DD-YYYY"
          style={{ width: "50%", marginBottom: 8 }}
          placeholder="Start Date"
          disabled={showBlanksOnly}
        />
        <DatePicker
          value={showBlanksOnly ? null : localEndDate}
          onChange={(date) => setLocalEndDate(date)}
          format="MM-DD-YYYY"
          style={{ width: "50%", marginBottom: 8 }}
          placeholder="End Date"
          disabled={showBlanksOnly}
        />
      </div>

      {/* Add checkbox for blank option */}
      <div style={{ marginBottom: 8 }}>
        <Checkbox
          checked={showBlanksOnly}
          onChange={(e) => handleBlankToggle(e.target.checked)}
        >
          [Blank]
        </Checkbox>
      </div>

      <div className="d-flex justify-content-between flex-row-reverse">
        <Button
          type="primary"
          onClick={handleConfirm}
          size="small"
          disabled={!showBlanksOnly && (!localStartDate || !localEndDate)}
        >
          OK
        </Button>
        <Button onClick={handleReset} size="small" style={{ width: 90 }}>
          Reset
        </Button>
      </div>
    </div>
  );
};

export default DateRangeFilter;
